var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"02be6091c1ed4daeeb66f43be05a8ddae8d8f0c4"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["engine-frontend@apollograph"]={id:"02be6091c1ed4daeeb66f43be05a8ddae8d8f0c4"};
      